import Box from "@mui/material/Box";
import Carousel from "react-material-ui-carousel";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { useTheme } from "@mui/material";
import { useStyles } from "./HMICarousel.styles";
import { useContainerHeight } from "hooks/useContainerHeight";

const INDICATORS_HEIGHT = 36;

interface HMICarouselProps {
    slides: React.ReactNode[];
    autoPlay?: boolean;
}

export const HMICarousel = ({ slides, autoPlay = false }: HMICarouselProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const [containerRef, containerHeight] = useContainerHeight<HTMLDivElement>(INDICATORS_HEIGHT);

    return (
        <Box className={classes.root}>
            <Box ref={containerRef} className={classes.carouselArea}>
                <Carousel
                    autoPlay={autoPlay}
                    indicators={true}
                    swipe={false}
                    height={containerHeight}
                    NextIcon={<ArrowForwardIosOutlinedIcon />}
                    PrevIcon={<ArrowBackIosNewOutlinedIcon />}
                    navButtonsAlwaysVisible={true}
                    indicatorIconButtonProps={{
                        style: {
                            marginTop: "10px",
                        },
                    }}
                    fullHeightHover={false}
                    navButtonsProps={{
                        style: {
                            backgroundColor: "transparent",
                            color: theme.palette.border.divider,
                            width: "16px !important",
                            height: "16px !important",
                            margin: `${theme.spacing(10)} 0 0 0`,
                            padding: 0,
                        },
                    }}
                >
                    {slides.map((slide, index) => (
                        <Box key={index} className={classes.slide}>
                            {slide}
                        </Box>
                    ))}
                </Carousel>
            </Box>
        </Box>
    );
};
